import { render } from "./ShowAndSearch.vue?vue&type=template&id=2ad4686a&scoped=true"
import script from "./ShowAndSearch.vue?vue&type=script&lang=js"
export * from "./ShowAndSearch.vue?vue&type=script&lang=js"

import "./ShowAndSearch.vue?vue&type=style&index=0&id=2ad4686a&lang=scss&scoped=true"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad4686a"]])

export default __exports__